import configure from '../configure'
import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export default {
  put (date) {
    return Vue.http.put(
      configure.api_url + 'dates/' + date.id,
      date
    ).then(response => {
      return response.data
    }, error => {
      return error
    })
  }
}



/** WEBPACK FOOTER **
 ** ./src/api/dates.js
 **/